import BotInboundReportingNavbar from './BotInboundReportingNavbar'

export default BotInboundReportingNavbar;
